const {NAMESPACE_MAPPING} = require('@wix/document-services-json-schemas/dist/constants.json')
const {
    migrateStructuredMegaMenuSubmenuDesign,
    migrateStructuredMegaMenuSubmenuLayout,
    SUBMENU_COMPONENT_TYPE
} = require('@wix/component-migration/migrateStylableHorizontalMenuToNewMenu')

const COMPONENT_STYLE_TYPE = 'ComponentStyle'
const VARIANT_RELATION_TYPE = 'VariantRelation'

const migrateStructuredMegaMenuSubmenu = (pageManager, component) => {
    const {components: megaMenuContainerItems} = component

    const submenuComponents = megaMenuContainerItems.reduce((acc, megaMenuContainerItem) => {
        const {components: megaMenuContainerItemComponents} = megaMenuContainerItem

        if (megaMenuContainerItemComponents.length === 0) return acc

        const componentsWithSubmenuType = megaMenuContainerItemComponents.filter(
            megaMenuContainerItemComponent => megaMenuContainerItemComponent.componentType === SUBMENU_COMPONENT_TYPE
        )

        return [...acc, ...componentsWithSubmenuType]
    }, [])

    if (submenuComponents.length === 0) return

    const submenuComponentStyleItems = submenuComponents.reduce((acc, submenuComponent) => {
        const styleItem = pageManager.data.getItem(NAMESPACE_MAPPING.style, submenuComponent.styleId)

        if (styleItem.type === COMPONENT_STYLE_TYPE) {
            return [...acc, styleItem]
        }

        const styleItems = styleItem.values.map(styleKey => {
            const cleanedStyleKey = styleKey.replace('#', '')
            const currentBreakpoint = pageManager.data.getItem(NAMESPACE_MAPPING.style, cleanedStyleKey)

            if (currentBreakpoint.type === VARIANT_RELATION_TYPE) {
                const variantKey = currentBreakpoint.to.replace('#', '')
                const variantStyleItem = pageManager.data.getItem(NAMESPACE_MAPPING.style, variantKey)

                return variantStyleItem
            }

            return currentBreakpoint
        })

        return [...acc, ...styleItems]
    }, [])

    migrateStructuredMegaMenuSubmenuDesign(submenuComponentStyleItems)

    submenuComponents.forEach(submenu => {
        const cleanDataQuery = submenu.dataQuery.replace('#', '')
        const dataItem = pageManager.data.getItem(NAMESPACE_MAPPING.data, cleanDataQuery)

        migrateStructuredMegaMenuSubmenuLayout(dataItem)
    })
}

module.exports = {
    migrateStructuredMegaMenuSubmenu
}
